import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import { API_URL } from '@/config';
import storage from '@/utils/storage';
import Axios from 'axios';
const axios = Axios.create({
  baseURL: API_URL
});
axios.interceptors.request.use(config => {
  const token = storage.getToken();

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  config.headers['Accept'] = 'application/json';
  return config;
});
axios.interceptors.response.use(resp => {
  if (resp.data?.data?.total === 0 && resp.data?.data?.items === null) {
    resp.data.data.items = [];
  }

  if (resp.data?.data?.total === 0 && resp.data?.data?.Items === null) {
    resp.data.data.Items = [];
  }

  if (resp.data.status !== 0 && resp.data.code !== 0) {
    _Message.error({
      content: resp.data.msg
    });

    return Promise.reject(new Error(resp.data.msg));
  }

  return resp.data;
}, err => {
  if (Axios.isAxiosError(err)) {
    if ([401, 403].includes(err?.response?.status)) {
      storage.clearToken();
      window.location.href = 'https://google.com';
    }

    if (err?.response?.status === 429) {
      return Promise.reject(new Error('请求频繁'));
    }

    return Promise.reject(err);
  } else {
    return Promise.reject(err);
  }
});
export default axios;